/** @jsx jsx */

/** @jsxFrag React.Fragment*/
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { CitationModule } from '@coursera-web/cds-labs';

import FrontPageModulesRenderer from 'bundles/front-page/components/FrontPageModulesRenderer';
import { useFrontPageContentData } from 'bundles/front-page/providers/FrontPageContentDataProvider';
import OnboardingModuleRenderer from 'bundles/front-page/redesign-modules/OnboardingModuleRenderer';
import AiModuleRenderer from 'bundles/front-page/redesign-modules/ai-assistance/AiModuleRenderer';
import CareerAcademyModuleRedesignModuleRenderer from 'bundles/front-page/redesign-modules/career-academy/CareerAcademyModuleRedesignModuleRenderer';
import CompactCollectionsModuleRenderer from 'bundles/front-page/redesign-modules/compact-collections/CompactCollectionsModuleRenderer';
import {
  getPopularAndTrendingCollectionData,
  getPopularByCategoryCollectionData,
} from 'bundles/front-page/redesign-modules/compact-collections/data/getCompactCollections';
import DomainsModuleRenderer from 'bundles/front-page/redesign-modules/domains/DomainsModuleRenderer';
import HeroBannerModuleRenderer from 'bundles/front-page/redesign-modules/hero-banner/HeroBannerModuleRenderer';
import MerchandisingBucketsModuleRenderer from 'bundles/front-page/redesign-modules/merchandising-buckets/MerchandisingBucketsModuleRenderer';
import PartnerLogosModuleRenderer from 'bundles/front-page/redesign-modules/partner-logos/PartnerLogosModuleRenderer';
import PromoUnitsModuleRenderer from 'bundles/front-page/redesign-modules/promo-units/PromoUnitsModuleRenderer';
import SpotlightCollectionsModuleRenderer from 'bundles/front-page/redesign-modules/spotlight-collections/SpotlightCollectionsModuleRenderer';
import TestimonialsModuleRedesignRenderer from 'bundles/front-page/redesign-modules/testimonials/TestimonialsModuleRedesignRenderer';
import getCertificationPrepSpotlightCollectionsData from 'bundles/front-page/utils/getCertificationPrepSpotlightCollections';
import getNewReleasesSpotlightCollectionsData from 'bundles/front-page/utils/getNewReleasesSpotlightCollections';
import { getPathwayDisclaimer } from 'bundles/unified-common/utils/getPathwaysDisclaimers';

const styles = {
  container: css`
    margin-top: var(--cds-spacing-200);
  `,
};

// Page content of LOHP Redesign Q3 2025
const FrontPageContent = () => {
  const { modules, loading } = useFrontPageContentData();

  if (loading) return null;

  let frontPageContentOutput;

  if (modules && modules.length > 0) {
    frontPageContentOutput = <FrontPageModulesRenderer modules={modules} />;
  } else {
    frontPageContentOutput = (
      <>
        <HeroBannerModuleRenderer />
        <MerchandisingBucketsModuleRenderer />
        <PartnerLogosModuleRenderer />
        <CompactCollectionsModuleRenderer {...getPopularAndTrendingCollectionData()} />
        <DomainsModuleRenderer />
        <SpotlightCollectionsModuleRenderer {...getNewReleasesSpotlightCollectionsData()} />
        <CareerAcademyModuleRedesignModuleRenderer />
        <OnboardingModuleRenderer />
        <SpotlightCollectionsModuleRenderer {...getCertificationPrepSpotlightCollectionsData()} />
        <CompactCollectionsModuleRenderer {...getPopularByCategoryCollectionData()} />
        <PromoUnitsModuleRenderer />
        <TestimonialsModuleRedesignRenderer />
      </>
    );
  }

  return (
    <main className="rc-FrontPageWrapper cds" data-catchpoint="front-page-application" data-e2e="cms-lohp-content">
      <div css={styles.container}>
        <AiModuleRenderer />
        {frontPageContentOutput}
        <CitationModule citations={getPathwayDisclaimer()} removeBottomPadding />
      </div>
    </main>
  );
};

export default FrontPageContent;
